import { AgnesButton, AgnesModal } from '@agnes/ui';
import React from 'react';
import { FileText, Paperclip, Send } from 'lucide-react';
import { BaseComponentProps } from '@/components/BaseComponentProps';
import { Conversa } from '@/types/conversacao/Conversa';

export interface ModalRubricasAnaliseLoteConversaProps extends BaseComponentProps {
  conversacao?: Conversa;
  open: boolean;
  onClose: () => void;
}

export function ModalRubricasAnaliseLoteConversa({
  conversacao,
  open,
  onClose,
}: ModalRubricasAnaliseLoteConversaProps) {
  const [draft, setDraft] = React.useState('');

  return (
    <AgnesModal
      open={open}
      title={`Conversação - ${conversacao?.nome}`}
      maxWidth="md"
      onClose={onClose}
      footer={
        <div className="flex w-full items-end gap-2">
          <button
            type="button"
            aria-label="Anexar"
            className="rounded-lg border border-agnes-border p-2 text-agnes-text-muted"
          >
            <Paperclip className="h-4 w-4" />
          </button>
          <input
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Escreva uma mensagem..."
            className="flex-1 rounded-lg border border-agnes-border px-3 py-2 text-sm outline-none"
          />
          <AgnesButton
            variant="primary"
            startIcon={<Send className="h-4 w-4" />}
            onClick={() => setDraft('')}
          >
            Enviar
          </AgnesButton>
        </div>
      }
    >
      <div className="flex flex-col gap-3">
        {conversacao?.mensagens.map((mensagem, i) => (
          <div
            key={i}
            className={`max-w-[80%] rounded-xl p-3 text-sm ${mensagem.id === 2 ? 'self-start bg-agnes-bg-muted' : 'self-end bg-agnes-primary/10'}`}
          >
            <p className="mb-1 text-xs font-semibold text-agnes-text-muted">
              {mensagem.autor} · {mensagem.enviadoEm}
            </p>
            <p className="text-agnes-text">{mensagem.conteudo}</p>
            {mensagem.arquivos?.map((f) => (
              <span
                key={f.nome}
                className="mt-2 flex items-center gap-2 rounded-lg border border-agnes-border bg-agnes-bg-surface px-2 py-1 text-xs text-agnes-primary"
              >
                <FileText className="h-3.5 w-3.5" /> {f.nome}
                <span className="text-agnes-text-muted">{f.tamanho}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </AgnesModal>
  );
}
